import React from 'react';
import { useScrollFade } from '../hooks/useScrollFade';
export function EmotionSection() {
  const {
    ref,
    isVisible
  } = useScrollFade();
  const benefits = [{
    title: 'Skin that bounces back.',
    description: 'Firmness restored without a single syringe.'
  }, {
    title: 'Texture, transformed.',
    description: 'Fine lines and pores visibly refined over weeks.'
  }, {
    title: 'Results that build.',
    description: 'Your collagen keeps working for months after your session.'
  }];
  return <section className="py-24 bg-warm-bg relative" data-id="element-85">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl" data-id="element-86">
        <div ref={ref} className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-87">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-text-dark leading-tight" data-id="element-88">
            The tightness. The texture. The glow. All yours — naturally.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 lg:gap-16" data-id="element-89">
          {benefits.map((benefit, index) => <div key={index} className={`flex flex-col items-center text-center transition-all duration-1000 delay-${index * 200} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} style={{
          transitionDelay: `${index * 150 + 300}ms`
        }} data-id="element-90">
              <span className="text-gold text-2xl mb-6" data-id="element-91">✦</span>
              <h3 className="font-serif text-xl md:text-2xl text-text-dark mb-4" data-id="element-92">
                {benefit.title}
              </h3>
              <p className="text-text-dark/70 leading-relaxed" data-id="element-93">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}